import React from 'react';

// This structure (FleetStep and its children) exists to rendering a task
// A task consists of several steps (RaidTask -> [LandStep, RaidStep, LaunchStep])
// A similar structure exists on the server for processing tasks
// It is not clear where information about the steps is to be stored, because this is kind of messy ;)
export default class FleetStep {
    constructor(type) {
        this.type = type;
    }

    doPreRenderPredictions(props, idx) {
    }

    doPostRenderPredictions(props, idx) {
    }

    _onPlanetChange(props, x, y, z) {
        let new_task = Object.assign({}, props.task, { location: { x: x, y: y, z: z } });
        props.onAssignTask(new_task);
    }

    _onResourceChange(props, resources) {
        let new_task = Object.assign({}, props.task, { resources: resources });
        props.onAssignTask(new_task);
    }

    isStepActive(props, idx) {
        return props.task.index === 0 && props.task.current_step === idx;
    }

    _isStepDone(props, idx) {
        return props.task.index === 0 && props.task.current_step > idx;
    }

    _hasStepStarted(props, idx) {
        return this.isStepActive(props, idx) || this._isStepDone(props, idx);
    }

    _renderDone(name, idx) {
        return (<div key={idx}>
            <span className="boring-info-text">{name}: </span>
            <span>Done!</span>
        </div>);
    }
}
